module.exports = __webpack_public_path__ + "img/layering&Middleware.1018c7c2.svg";